import React from 'react'
import TopItem from './TopItem'

export default function Top({articles}) {

  return (
    <div className='top-cont'>
        {articles.map((e, index) => 

        <TopItem key={index} {...e} />
          
        )}

<a target='_blank' href={`https://libraseguros.com.ar/`}  className='top-item-cont'>
        <img className='top-item-img' src="https://firebasestorage.googleapis.com/v0/b/autoprecios-f936b.appspot.com/o/banners%2F2025_LBR_BAN_OT_FojaCero300x250_v2.gif?alt=media&token=fa65de38-3c77-4430-858a-941041650914" alt="Libra Seguros" />


     
    </a>
    </div>
  )
}
